import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const getAllLabReport = createAsyncThunk(
  "/labReport/getAllLabReport",
  async (serchingFor, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/labReport/getAllLabReport",
        serchingFor,
        {
          headers: {
            "Content-Type": "application/json",
            token: serchingFor.token,
          },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);
export const getAllLabReportForCount = createAsyncThunk(
  "/labReport/getAllLabReportCount",
  async (serchingFor, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/labReport/getAllLabReportCount",
        serchingFor,
        {
          headers: {
            "Content-Type": "application/json",
            token: serchingFor.token,
          },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const getOutSourceToLabReport = createAsyncThunk(
  "/labReport/getOutSourceToLabReport",
  async (serchingFor, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/labReport/getOutSourceToLabReport",
        serchingFor,
        {
          headers: {
            "Content-Type": "application/json",
            token: serchingFor.token,
          },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const getOutSourceFromLabReport = createAsyncThunk(
  "/labReport/getOutSourceFromLabReport",
  async (serchingFor, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/labReport/getOutSourceFromLabReport",
        serchingFor,
        {
          headers: {
            "Content-Type": "application/json",
            token: serchingFor.token,
          },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);
export const getLabReportsSharedClinic = createAsyncThunk(
  "/labReport/getLabReportsSharedWithClinic",
  async (serchingFor, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/labReport/getLabReportsSharedWithClinic",
        serchingFor,
        {
          headers: {
            "Content-Type": "application/json",
            token: serchingFor.token,
          },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const updateBranchInLabReport = createAsyncThunk(
  "/labReport/updateBranchInLabReport",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/labReport/updateBranchInLabReport",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token,
          },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);
export const updateLabReport = createAsyncThunk(
  "/labReport/updateLabReport",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put("/labReport/updateLabReport", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const getAllLabReportRegistrationStates = createAsyncThunk(
  "/labReport/getAllLabReportRegistrationState",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/labReport/getAllLabReportRegistrationState",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token,
          },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const getLatestLabReportByPatient = createAsyncThunk(
  "/labReport/getLatestLabReportByPatient",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/labReport/getLatestLabReportByPatient",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token,
          },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const getPatientLabReports = createAsyncThunk(
  "/labReport/getPatientLabReports",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/labReport/getPatientLabReports",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token,
          },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const sendWhatsappReport = createAsyncThunk(
  "/labReport/sendWhatsappReport",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axios.post("/labReport/sendWhatsapp", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          token: formData.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);
export const sendLabReportMail = createAsyncThunk(
  "labReport/sendLabReportMail",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/labReport/sendLabReportMail",
        formData,
        {
          headers: {
            token: formData.token,
            "Content-Type": "multipart/form-data",
          },
        },
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);
const initialState = {
  loading: false,
  labReport: [],
  count: [],
  labreportShareClinic: [],
  latestPatientLabReport: null,
  patientLabReports: [],
  patientLabReportsLoading: false,
  patientLabReportsForPatientId: null,
  patientLabReportsRequestId: null,
  labReportUpdateSuccessMessage: null,
  labReportUpdateErrorMessage: null,
  labBranchUpdateSuccessMessage: null,
  labBranchUpdateErrorMessage: null,
  labStatus: {
    yesterdayLabReportCount: 0,
    todayLabReportCount: 0,
    registrationLabtPercentage: "0%",
  },
  currentPage: 1,
  totalPages: null,
  hasMore: true,
  totalCount: 0,
  whatsappLoading: false,
  whatsappSuccessMessage: null,
  whatsappErrorMessage: null,
  emailLoading: false,
  emailSuccessMessage: null,
  emailErrorMessage: null,
};

const labReportSlice = createSlice({
  name: "labReport",
  initialState,
  reducers: {
    resetUpdateLabReportMessage: (state) => {
      state.labReportUpdateSuccessMessage = null;
      state.labReportUpdateErrorMessage = null;
    },
    resetBranchMessage: (state) => {
      state.labBranchUpdateSuccessMessage = null;
      state.labBranchUpdateErrorMessage = null;
    },
    resetLabReport: (state) => {
      state.labReport = [];
      state.labStatus = {
        yesterdayLabReportCount: 0,
        todayLabReportCount: 0,
        registrationLabtPercentage: "0%",
      };
    },
    resetPatientLabReportsState: (state) => {
      state.patientLabReports = [];
      state.patientLabReportsLoading = false;
      state.patientLabReportsForPatientId = null;
      state.patientLabReportsRequestId = null;
    },
    resetWhatsappMessage: (state) => {
      state.whatsappLoading = false;
      state.whatsappSuccessMessage = null;
      state.whatsappErrorMessage = null;
    },
    resetEmailMessage: (state) => {
      state.emailLoading = false;
      state.emailSuccessMessage = null;
      state.emailErrorMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllLabReport.pending, (state) => {
        state.loading = true;
      })

      .addCase(getAllLabReport.fulfilled, (state, action) => {
        state.loading = false;

        if (!action.payload.success) {
          state.labReport = [];
          state.totalCount = 0;
          state.totalPages = 1;
          state.searchMessage =
            action.payload.result?.message || "No data found";
          return;
        }

        const result = action.payload.result;
        state.labReport = result.list || [];
        state.currentPage = Number(result.currentPage) || 1;
        state.totalPages = Number(result.totalPages) || 1;
        state.totalCount = Number(result.totalRecords) || 0;
        state.hasMore = result.hasMore ?? false;
        state.searchMessage = null;
      })

      .addCase(getAllLabReport.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getAllLabReportForCount.pending, (state) => {
        state.loading = true;
      })

      .addCase(getAllLabReportForCount.fulfilled, (state, action) => {
        state.loading = false;

        if (!action.payload.success) {
          state.count = [];
          state.searchMessage =
            action.payload.result?.message || "No data found";
          return;
        }

        const result = action.payload.result;
        state.count = result.list || [];
        state.searchMessage = null;
      })

      .addCase(getAllLabReportForCount.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(getLabReportsSharedClinic.pending, (state) => {
        state.loading = true;
      })
      .addCase(getLabReportsSharedClinic.fulfilled, (state, action) => {
        state.loading = false;

        if (!action.payload.success) {
          state.labreportShareClinic = [];
          state.totalCount = 0;
          state.totalPages = 1;
          state.searchMessage =
            action.payload.result?.message || "No data found";
          return;
        }

        const result = action.payload.result;
        state.labreportShareClinic = result.list || [];
        state.currentPage = Number(result.currentPage) || 1;
        state.totalPages = Number(result.totalPages) || 1;
        state.totalCount = Number(result.totalRecords) || 0;
        state.hasMore = result.hasMore ?? false;
        state.searchMessage = null;
      })

      .addCase(getLabReportsSharedClinic.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(updateLabReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateLabReport.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.labReportUpdateErrorMessage = action.payload.result.message;
        } else {
          state.labReportUpdateSuccessMessage = action.payload.result.message;
        }
      })
      .addCase(updateLabReport.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(updateBranchInLabReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateBranchInLabReport.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.labBranchUpdateErrorMessage = action.payload.result.message;
        } else {
          state.labBranchUpdateSuccessMessage = action.payload.result.message;
        }
      })
      .addCase(updateBranchInLabReport.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getOutSourceToLabReport.pending, (state) => {
        state.loading = true;
      })

      .addCase(getOutSourceToLabReport.fulfilled, (state, action) => {
        state.loading = false;

        if (!action.payload.success) {
          state.labReport = [];
          state.totalCount = 0;
          state.totalPages = 1;
          state.searchMessage =
            action.payload.result?.message || "No data found";
          return;
        }

        const result = action.payload.result;
        state.labReport = result.list || [];
        state.currentPage = Number(result.currentPage) || 1;
        state.totalPages = Number(result.totalPages) || 1;
        state.totalCount = Number(result.totalRecords) || 0;
        state.hasMore = result.hasMore ?? false;
        state.searchMessage = null;
      })
      .addCase(getOutSourceToLabReport.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getOutSourceFromLabReport.pending, (state) => {
        state.loading = true;
      })

      .addCase(getOutSourceFromLabReport.fulfilled, (state, action) => {
        state.loading = false;

        if (!action.payload.success) {
          state.labReport = [];
          state.totalCount = 0;
          state.totalPages = 1;
          state.searchMessage =
            action.payload.result?.message || "No data found";
          return;
        }

        const result = action.payload.result;
        state.labReport = result.list || [];
        state.currentPage = Number(result.currentPage) || 1;
        state.totalPages = Number(result.totalPages) || 1;
        state.totalCount = Number(result.totalRecords) || 0;
        state.hasMore = result.hasMore ?? false;
        state.searchMessage = null;
      })
      .addCase(getOutSourceFromLabReport.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getAllLabReportRegistrationStates.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllLabReportRegistrationStates.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.errorMessage = action.payload.result.message;
        } else {
          state.labStatus = action.payload.result.list;
        }
      })
      .addCase(getAllLabReportRegistrationStates.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage = action.payload;
      })
      .addCase(getLatestLabReportByPatient.pending, (state) => {
        state.loading = true;
      })
      .addCase(getLatestLabReportByPatient.fulfilled, (state, action) => {
        state.loading = false;
        if (!action.payload?.success) {
          state.latestPatientLabReport = null;
          return;
        }
        state.latestPatientLabReport = action.payload?.result || null;
      })
      .addCase(getLatestLabReportByPatient.rejected, (state) => {
        state.loading = false;
      })
      .addCase(getPatientLabReports.pending, (state, action) => {
        state.patientLabReportsLoading = true;
        state.patientLabReports = [];
        state.patientLabReportsForPatientId = String(
          action.meta.arg?.patientId || "",
        );
        state.patientLabReportsRequestId = action.meta.requestId;
      })
      .addCase(getPatientLabReports.fulfilled, (state, action) => {
        if (state.patientLabReportsRequestId !== action.meta.requestId) return;
        state.patientLabReportsLoading = false;
        if (!action.payload?.success) {
          state.patientLabReports = [];
          return;
        }
        const requestedPatientId = String(action.meta.arg?.patientId || "");
        const list = action.payload?.result?.list || [];
        state.patientLabReports = list.filter((item) => {
          const rowPatientId = String(item?.patientId || "");
          return !rowPatientId || rowPatientId === requestedPatientId;
        });
      })
      .addCase(getPatientLabReports.rejected, (state, action) => {
        if (state.patientLabReportsRequestId !== action.meta.requestId) return;
        state.patientLabReportsLoading = false;
        state.patientLabReports = [];
      })
      .addCase(sendWhatsappReport.pending, (state) => {
        state.whatsappLoading = true;
        state.whatsappSuccessMessage = null;
        state.whatsappErrorMessage = null;
      })

      .addCase(sendWhatsappReport.fulfilled, (state, action) => {
        state.whatsappLoading = false;

        if (action.payload.success) {
          state.whatsappSuccessMessage = action.payload.result.message;
        } else {
          state.whatsappErrorMessage = action.payload.result.message;
        }
      })

      .addCase(sendWhatsappReport.rejected, (state, action) => {
        state.whatsappLoading = false;
        state.whatsappErrorMessage = action.payload;
      })
      .addCase(sendLabReportMail.pending, (state) => {
        state.emailLoading = true;
        state.emailSuccessMessage = null;
        state.emailErrorMessage = null;
      })
      .addCase(sendLabReportMail.fulfilled, (state, action) => {
        state.emailLoading = false;
        if(action.payload.success){
          state.emailSuccessMessage = action.payload.result.message;
        }else{
          state.emailErrorMessage = action.payload.result.message;
        }
      })
      .addCase(sendLabReportMail.rejected, (state, action) => {
        state.loading = false;
        state.emailErrorMessage = action.payload.result.message;
      });
  },
});

export const {
  resetUpdateLabReportMessage,
  resetLabReport,
  resetBranchMessage,
  resetPatientLabReportsState,
  resetEmailMessage,
  resetWhatsappMessage,
} = labReportSlice.actions;

export default labReportSlice.reducer;
